import { useNavigate } from 'react-router-dom';
import { Card, message, theme } from 'antd';
import { PageHeader } from '../../components/PageHeader';
import { PlanForm } from './components/PlanForm';
import { useCreatePlan } from './api/usePlanes';
import { useHasPermission } from '../../auth/useHasPermission';
import { Permission } from '@aid/shared';

export function PlanCreatePage() {
  const navigate = useNavigate();
  const createPlan = useCreatePlan();
  const hasPermission = useHasPermission(Permission.PLANES_CREATE);
  const { token } = theme.useToken();

  if (!hasPermission) {
    return <div>No tienes permiso para crear planes.</div>;
  }

  const handleSubmit = async (values: Record<string, unknown>) => {
    try {
      await createPlan.mutateAsync(values as Parameters<typeof createPlan.mutateAsync>[0]);
      message.success('Plan creado correctamente');
      navigate('/planes');
    } catch {
      message.error('Error al crear el plan');
    }
  };

  return (
    <div>
      <PageHeader title="Crear plan" subtitle="Crear un nuevo plan de servicio" />
      <Card
        style={{
          borderRadius: 12,
          border: `1px solid ${token.colorBorderSecondary}`,
          boxShadow: token.boxShadow,
        }}
      >
        <PlanForm mode="create" onSubmit={handleSubmit} loading={createPlan.isPending} />
      </Card>
    </div>
  );
}
